var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"card-c",attrs:{"title":"历史人数演变"}},[_c('div',{ref:"c1",staticClass:"c-s"})])}
var staticRenderFns = []

export { render, staticRenderFns }